import React from 'react';

// Hay cierta lógica que tener en cuenta, si viene el parámetro blankLine se entiende que es la nueva forma de Mazda, con dos
// párrafos separados. Si este parámetro no viene se entiende que es la forma antigua en una sola frase
const customCheckbox = ({ input, name, label1, label2, tick, a, href, target, className, meta: { touched, error }, a2, href2, blankLine }) => (
  <div className={className}>
    <div className="checkBox-label-inline">
      <input {...input} name={name || input.name} type="checkbox" className={(touched && error)
        ? 'form-control form-control__checkbox is-invalid'
        : 'form-control form-control__checkbox'} />
      {tick && <div className="checkmark_stem" />}
      {tick && <div className="checkmark_kick" />}
      {label1 && <label className="form-item-flex__label">{label1}{a && href && target && <a href={href} target='_blank'>{a}</a>}</label>}
      {!blankLine && label2}
    </div>
    { blankLine && <span className="span-margin-bottom"></span>}
    { blankLine && label2 && <label className="form-item-flex__label">{label2}{a2 && href2 && target && <a href={href2} target='_blank'>{a2}</a>}</label>}
    {touched && error && <span className="invalid-feedback">{error}</span>}
  </div>
)

export default customCheckbox;


// WEBPACK FOOTER //
// ./src/components/Checkbox/CheckBoxComponent.js